// extracted by mini-css-extract-plugin
export default {"header_space_box":"cpns_header_space_box__WkK0H","header_item_icon_size":"cpns_header_item_icon_size__DYVas"};